module.exports = __webpack_public_path__ + "img/trash.7fe16b6c.svg";